export default "__VITE_ASSET__BzzMozD8__"